import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../../context/AppContext";
import EnquiryListPanel from "./EnquiryListPanel";
import { toDateKey, matchesStatusFilter } from "./TodaysEnquiries";

function parseBookingDate(bookingTime) {
  if (!bookingTime) return null;
  const raw = String(bookingTime).trim();
  const normalized = raw.includes("T") ? raw : raw.replace(" ", "T");
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

function startOfTomorrow() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 1);
  return d;
}

function UpcomingEnquiries({ keyword, searchDate, statusFilter = "all" }) {
  const { upcomingEnquiries, reservationLoading } = useContext(AppContext);
  const [displayList, setDisplayList] = useState([]);

  const upcomingSource = useMemo(() => {
    const list = Array.isArray(upcomingEnquiries) ? upcomingEnquiries : [];
    const tomorrow = startOfTomorrow();

    return list
      .filter((item) => {
        const status = item?.status;
        if (
          status === "Cancelled" ||
          status === "Rejected" ||
          status === "Completed" ||
          status === "Expired"
        ) {
          return false;
        }
        const bookingDate = parseBookingDate(item?.bookingTime);
        if (!bookingDate) return false;
        return bookingDate >= tomorrow;
      })
      .sort((a, b) => {
        const da = parseBookingDate(a?.bookingTime)?.getTime() || 0;
        const db = parseBookingDate(b?.bookingTime)?.getTime() || 0;
        return da - db;
      });
  }, [upcomingEnquiries]);

  useEffect(() => {
    let filtered = upcomingSource;

    if (searchDate) {
      filtered = filtered.filter(
        (item) => toDateKey(item?.bookingTime) === searchDate
      );
    }

    filtered = filtered.filter((item) =>
      matchesStatusFilter(item, statusFilter)
    );

    if (keyword && keyword.length !== 0) {
      const kw = keyword.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item?.name?.toLowerCase?.().includes(kw) ||
          item?.email?.toLowerCase?.().includes(kw) ||
          item?.formattedID?.toLowerCase?.().includes(kw) ||
          String(item?.phone || "").includes(keyword)
      );
    }

    setDisplayList(filtered);
  }, [upcomingSource, keyword, searchDate, statusFilter]);

  const emptyMessage =
    statusFilter === "all"
      ? "No Upcoming Enquiries"
      : statusFilter === "needs_approval"
        ? "No upcoming reservations need approval"
        : `No ${statusFilter === "Approved" ? "Confirmed" : statusFilter} upcoming reservations`;

  return (
    <Fragment>
      <EnquiryListPanel
        title="Upcoming reservations"
        items={displayList}
        loading={reservationLoading}
        emptyMessage={emptyMessage}
        showStatus
      />
    </Fragment>
  );
}

export default UpcomingEnquiries;
